import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuard } from './auth-guard.service';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'dashboard',
        loadChildren: './page/dashboard/dashboard.module#DashboardModule'
      },
      {
        data: { 'access_role': [1] },
        canActivate: [AuthGuard],
        path: 'client',
        loadChildren: './page/client/client.module#ClientModule'
      },
      {
        data: { 'access_role': [1] },
        canActivate: [AuthGuard],
        path: 'agent',
        loadChildren: './page/agent/agent.module#AgentModule'
      },
      {
        data: { 'access_role': [2] },
        canActivate: [AuthGuard],
        path: 'assignTask',
        loadChildren: './page/assignTask/assignTask.module#AssignTaskModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'group',
        loadChildren: './page/group/group.module#GroupModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'movegroup',
        loadChildren: './page/movegroup/movegroup.module#MovegroupModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'changePassword',
        loadChildren: './page/changePassword/changePassword.module#ChangePasswordModule'
      },
      // {
      //   data: { 'access_role': [1, 2, 3] },
      //   canActivate: [AuthGuard],
      //   path: 'department',
      //   loadChildren: './page/department/department.module#DepartmentModule'
      // },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'designation',
        loadChildren: './page/designation/designation.module#DesignationModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'subgroup',
        loadChildren: './page/subgroup/subgroup.module#SubgroupModule'

      },
      {
        data: { 'access_role': [1, 3] },
        canActivate: [AuthGuard],
        path: 'country',
        loadChildren: './page/country/country.module#CountryModule'

      },
      {
        data: { 'access_role': [1, 3] },
        canActivate: [AuthGuard],
        path: 'state',
        loadChildren: './page/state/state.module#StateModule'

      },
      {
        data: { 'access_role': [1, 3] },
        canActivate: [AuthGuard],
        path: 'city',
        loadChildren: './page/city/city.module#CityModule'

      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'template',
        loadChildren: './page/template/template.module#TemplateModule'

      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'manageData/studentData',
        loadChildren: './page/manageData/studentData/studentData.module#studentDataModule'

      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'manageData/generalData',
        loadChildren: './page/manageData/generalData/generalData.module#generalDataModule'
      },
      {
        path: 'reports/:params',
        loadChildren: './page/reports/reports.module#ReportModule'
      },
      // {
      //   path: ':params',
      //   loadChildren: './page/reports/reports.module#ReportModule'
      // },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'subject',
        loadChildren: './page/subject/subject.module#SubjectModule'

      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'rank',
        loadChildren: './page/rank/rank.module#RankModule'

      },
      {
        data: { 'access_role': [2, 3], 'permission': 5 },
        canActivate: [AuthGuard],
        path: 'attendance',
        loadChildren: './page/attendance/attendance.module#AttendanceModule'

      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'subscription',
        loadChildren: './page/subscription/subscription.module#SubscriptionModule'
      },
      {
        data: { 'access_role': [2] },
        canActivate: [AuthGuard],
        path: 'subusers',
        loadChildren: './page/subusers/subusers.module#SubUsersModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 3 },
        canActivate: [AuthGuard],
        path: 'result',
        loadChildren: './page/result/result.module#ResultModule'
      },
      // {
      //   path: 'test',
      //   loadChildren: './page/result/test/test.module#TestModule'
      // },
      // {
      //   path: 'exam',
      //   loadChildren: './page/result/exam/exam.module#ExamModule'
      // },
      {
        data: { 'access_role': [2, 3], 'permission': 4 },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/homework/homework.module#HomeworkModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/memo/memo.module#MemoModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 6 },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/notice/notice.module#NoticeModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 7 },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/circulars/circulars.module#CircularsModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 8 },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/invitation/invitation.module#InvitationModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/announcement/announcement.module#AnnouncementModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/happenings/happenings.module#HappeningsModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/beAlert/beAlert.module#BeAlertModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'others',
        loadChildren: './page/examWish/examWish.module#ExamWishModule'
      },
      {
        data: { 'access_role': [2, 3]},
        canActivate: [AuthGuard],
        path: 'greetings',
        loadChildren: './page/greetings/greetings.module#GreetingsModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'graph',
        loadChildren: './page/graph/graph.module#ViaTextModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 9 },
        canActivate: [AuthGuard],
        path: 'promotion',
        loadChildren: './page/promotion/promotion.module#promotionGroupModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 10 },
        canActivate: [AuthGuard],
        path: 'inquiries',
        loadChildren: './page/inquiries/inquiries.module#InquiriesModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 10 },
        canActivate: [AuthGuard],
        path: 'inquiriesFollowup',
        loadChildren: './page/inquiriesFollowup/inquiriesFollowup.module#InquiriesFollowupModule'
      },
      {
        data: { 'access_role': [2]},
        canActivate: [AuthGuard],
        path: 'birthday',
        loadChildren: './page/birthday/birthday.module#BirthdayModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'fee',
        loadChildren: './page/fee/fee.module#FeeModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'fee',
        loadChildren: './page/feeAdd/feeAdd.module#FeeAddModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'fee',
        loadChildren: './page/feeReceived/feeReceived.module#FeeReceivedModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'fee',
        loadChildren: './page/feeDue/feeDue.module#FeeDueModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'fee',
        loadChildren: './page/ataGlance/ataGlance.module#AtaGlanceModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 11 },
        canActivate: [AuthGuard],
        path: 'smsDelivery',
        loadChildren: './page/smsDelivery/smsDelivery.module#SmsDeliveryModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 5 },
        canActivate: [AuthGuard],
        path: 'attendanceReport',
        loadChildren: './page/attendanceReport/attendanceReport.module#AttendanceReportModule'
      },
      {
        data: { 'access_role': [2, 3], 'permission': 3 },
        canActivate: [AuthGuard],
        path: 'resultReport',
        loadChildren: './page/resultReport/resultReport.module#ResultReportModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'feeReport',
        loadChildren: './page/feeReport/feeReport.module#FeeReportModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'page/subscriptionRequest',
        loadChildren: './page/subscriptionRequest/subscriptionRequest.module#SubscriptionRequestModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'page/subscriptionRequestsms',
        loadChildren: './page/subscriptionRequestsms/subscriptionRequestsms.module#SubscriptionRequestsmsModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'trainingRequest',
        loadChildren: './page/trainingRequest/trainingRequest.module#TrainingRequestModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'feedback',
        loadChildren: './page/feedback/feedback.module#FeedbackModule'
      },
      {
        data: { 'access_role': [2, 3] },
        canActivate: [AuthGuard],
        path: 'referenceData',
        loadChildren: './page/referenceData/referenceData.module#ReferenceDataModule'
      },
      {
        data: { 'access_role': [1] },
        canActivate: [AuthGuard],
        path: 'aceAlertInquiry',
        loadChildren: './page/aceAlertInquiry/aceAlertInquiry.module#AceAlertInquiryModule'
      },
      {
        data: { 'access_role': [1] },
        canActivate: [AuthGuard],
        path: 'referFollowup',
        loadChildren: './page/referFollowup/referFollowup.module#ReferFollowupModule'
      },
      {
        data: { 'access_role': [1] },
        canActivate: [AuthGuard],
        path: 'news',
        loadChildren: './page/news/news.module#NewsModule'
      },
      {
        data: { 'access_role': [1] },
        canActivate: [AuthGuard],
        path: 'userActivity',
        loadChildren: './page/userActivity/userActivity.module#UserActivityModule'
      },
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'profile',
        loadChildren: './page/profile/profile.module#profileModule'
      },
      // {
      //   data: { 'access_role': [2] },
      //   canActivate: [AuthGuard],
      //   path: 'birthday',
      //   loadChildren: './page/birthday/birthday.module#birthdayModule'
      // },
      /*--------------------------------- */
      {
        data: { 'access_role': [1, 2, 3] },
        canActivate: [AuthGuard],
        path: 'dashboard',
        loadChildren: './theme/dashboard/dashboard.module#DashboardModule'
      },
      // {
      //   path: 'navigation',
      //   loadChildren: './theme/navigation/navigation.module#NavigationModule'
      // },
      // {
      //   path: 'widget',
      //   loadChildren: './theme/widget/widget.module#WidgetModule'
      // },
      // {
      //   path: 'basic',
      //   loadChildren: './theme/ui-elements/basic/basic.module#BasicModule'
      // },
      // {
      //   path: 'advance',
      //   loadChildren: './theme/ui-elements/advance/advance.module#AdvanceModule'
      // },
      // {
      //   path: 'animations',
      //   loadChildren: './theme/ui-elements/animation/animation.module#AnimationModule'
      // },
      // {
      //   path: 'forms',
      //   loadChildren: './theme/forms/forms.module#FormsModule'
      // },
      // {
      //   path: 'bootstrap-table',
      //   loadChildren: './theme/table/bootstrap-table/bootstrap-table.module#BootstrapTableModule'
      // },
      // {
      //   path: 'data-table',
      //   loadChildren: './theme/table/data-table/data-table.module#DataTableModule'
      // },
      // {
      //   path: 'user',
      //   loadChildren: './theme/user/user.module#UserModule'
      // },
      // {
      //   path: 'email',
      //   loadChildren: './theme/email/email.module#EmailModule'
      // },
      // {
      //   path: 'crm-contact',
      //   loadChildren: './theme/crm-contact/crm-contact.module#CrmContactModule'
      // },
      // {
      //   path: 'task',
      //   loadChildren: './theme/task/task.module#TaskModule'
      // },
      // {
      //   path: 'editor',
      //   loadChildren: './theme/extension/editor/editor.module#EditorModule'
      // },
      // {
      //   path: 'invoice',
      //   loadChildren: './theme/extension/invoice/invoice.module#InvoiceModule'
      // },
      // {
      //   path: 'file-upload-ui',
      //   loadChildren: './theme/extension/file-upload-ui/file-upload-ui.module#FileUploadUiModule'
      // },
      // {
      //   path: 'calendar',
      //   loadChildren: './theme/extension/event-calendar/event-calendar.module#EventCalendarModule'
      // },
      // {
      //   path: 'charts',
      //   loadChildren: './theme/chart/chart.module#ChartModule'
      // },
      // {
      //   path: 'map',
      //   loadChildren: './theme/map/map.module#MapModule'
      // },
      // {
      //   path: 'simple-page',
      //   loadChildren: './theme/simple-page/simple-page.module#SimplePageModule'
      // }
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: './theme/auth/auth.module#AuthModule'
      },
      // {
      //   path: 'maintenance/error',
      //   loadChildren: './theme/maintenance/error/error.module#ErrorModule'
      // },
      // {
      //   path: 'maintenance/coming-soon',
      //   loadChildren: './theme/maintenance/coming-soon/coming-soon.module#ComingSoonModule'
      // },
      // {
      //   path: 'email/email-template',
      //   loadChildren: './theme/email/email-template/email-template.module#EmailTemplateModule'
      // },
      // {
      //   path: 'maintenance/offline-ui',
      //   loadChildren: './theme/maintenance/offline-ui/offline-ui.module#OfflineUiModule'
      // }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
